import { useEffect, useState } from 'react';

const ROOT_MARGIN = '200px';

/**
 * Nachladen an einem Fühler am Listenende statt an einem Scroll-Listener: welcher
 * Vorfahr scrollt (Seitenspalte, eigenes Fenster, Dokument), entscheidet der Rahmen —
 * der Beobachter misst gegen den Viewport und kommt ohne diese Kenntnis aus.
 *
 * Der zurückgegebene Callback-Ref gehört an einen leeren `<div aria-hidden />` direkt
 * unter der Liste. Ein Element ohne Höhe gilt dem `IntersectionObserver` als sichtbar,
 * sobald es im Beobachtungsbereich liegt. Der Beobachter wird bei jeder Änderung der drei
 * Parameter oder des Fühler-Knotens neu aufgebaut: ein Fühler, der nach dem Laden einer
 * Seite noch sichtbar ist, löst so genau eine weitere Seite aus, und ein Fühler, den die
 * Liste nach einem Fehlerzustand neu mountet, wird wieder beobachtet.
 */
export function useLoadMoreSentinel({ hasNextPage, isFetchingNextPage, fetchNextPage }) {
  const [node, setNode] = useState(null);
  useEffect(() => {
    if (!node || !hasNextPage) return undefined;
    const observer = new IntersectionObserver((eintraege) => {
      if (eintraege.some((e) => e.isIntersecting) && !isFetchingNextPage) fetchNextPage();
    }, { rootMargin: ROOT_MARGIN });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, hasNextPage, isFetchingNextPage, fetchNextPage]);
  return setNode;
}
